import {ServiceRequest} from "../utils/service-request"
import {LOTES_DADOS_EXTERNOS_PATH, MOTOR_CADASTRO_LOTE_UPLOAD_PATH} from "../utils/api-routes"

class MotorWorkflowService {

    constructor() {
        this.request = new ServiceRequest()
    }

    async getWorkflows() {
        const params = new URLSearchParams({
            limit: 8000,
            offset: 0,
            rotina_grupo: 'MOTOR_CADASTRO',
        })

        return this.request.get(`${LOTES_DADOS_EXTERNOS_PATH}?${params.toString()}`)
    }

    async downloadReport(id) {
        return this.request.getBlob(`${LOTES_DADOS_EXTERNOS_PATH}/${id}/reports_download`)
    }

    async getWorkflowsType() {
        return this.request.get(`${MOTOR_CADASTRO_LOTE_UPLOAD_PATH}`)
    }

    async postUploadCadastroLote({ arquivo, model, projetar_eventos }) {
        const path = MOTOR_CADASTRO_LOTE_UPLOAD_PATH

        const formData = new FormData()

        formData.append("arquivo", arquivo)
        formData.append("model", model)
        formData.append("projetar_eventos", projetar_eventos)

        return this.request.postFormData(path, formData)
    }

}

export default MotorWorkflowService